import {
  Box,
  Button,
  Container,
  Grid,
  Header,
  Modal,
  SpaceBetween
} from '@cloudscape-design/components';
import { DocumentContext } from '../../context/documentContext';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { createFile } from '../../helpers/createDocx';
import { createMultiDocSheet } from '../../helpers/createExcelMultiDoc';

export const Reports = () => {
  const { setCurrentDocId, currentDoc, sentences, removeAllKBReferences, domains, controls, auth } =
    useContext(DocumentContext);
  const [queryParameters] = useSearchParams();
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [pageType, setPageType] = useState<string>('');
  const [showOverview, setShowOverview] = useState<boolean>(false);
  const [showEntireDocument, setShowEntireDocument] = useState<boolean>(false);

  useEffect(() => {
    if (queryParameters.get('documentId')) {
      console.log('query ', queryParameters.get('documentId'));
      setCurrentDocId(queryParameters.get('documentId')!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters]);

  return (
    <>
      {!showDetail && !showOverview && !showEntireDocument ? (
        <Container
          header={
            <Header>
              <SpaceBetween direction="vertical" size="s">
                <h1>Create Reports</h1>
                <SpaceBetween size={'s'} direction="horizontal">
                  <Button
                    variant="primary"
                    onClick={() =>
                      createFile(currentDoc.documentFileName, sentences, "")
                    }
                  >
                    Redline Report
                  </Button>
                  <Button
                    variant="primary"
                    // disabled={!(selectedItems.length > 0)}
                    onClick={() =>
                      createMultiDocSheet(
                        [currentDoc],
                        domains,
                        controls,
                        auth
                      )
                    }
                  >
                    Create XLS
                  </Button>
                  {/* <Button onClick={() => removeAllKBReferences()}>
                    Remove all references to sentences
                  </Button> */}
                </SpaceBetween>
              </SpaceBetween>
            </Header>
          }
        ></Container>
      ) : null}
    </>
  );
};
